
import { FiCoffee, FiZap, FiFolder, FiBookOpen, FiMenu } from "react-icons/fi";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { ThemeToggle } from "./ThemeToggle.tsx";

export function Navbar() {
  const [logged, setlogged] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("token") == null || localStorage.getItem("token") == undefined) {
      setlogged(false);
    } else {
      setlogged(true);
    }
  }, []);

  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <header>
      <nav className="navbar">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <div className="logo" onClick={() => navigate("/")} style={{ cursor: 'pointer' }}>
            <FiCoffee /> CoffeeLaTek
          </div>
          <ThemeToggle />
        </div>
        
        <button className="mobile-menu-toggle" aria-label="Toggle Navigation" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <FiMenu />
        </button>

        <div className={`nav-container ${mobileMenuOpen ? 'active' : ''}`}>
          <ul className="nav-links">
            <li><a href="#features"><FiZap /> Features</a></li>
            <li><a href="/search"><FiFolder /> Projects</a></li>
            <li><a href="/documentation"><FiBookOpen /> Documentation</a></li>
          </ul>
          <div className="nav-actions">
            {logged === false ? (
              <>
                <button className="button button-clear" onClick={() => navigate("/login")}>Login</button>
                <button className="button" onClick={() => navigate("/signup")}>Signup</button>
              </>
            ) : (
              <button className="button" onClick={logout}>Logout</button>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
}
